module.exports = __webpack_public_path__ + "img/荣誉证书02_企业资信等级证书.ff36fd46.png";